import {action} from 'mobx';
import {authStore} from '../../store/stores/auth-store';
import {activateNotification} from '../../ui/molecules/notification/activate-notification';
import {capitalize} from '../../utils';
import {convertFormDataToAPIformat} from '../../utils/convertFormData';
import {computeFrameworkVars} from '../../utils/framework';
import {CreateGoalFormData} from './create-goal-interface';
import {CreateGoalRequest} from './create-goal-request';

export class CreateGoalController {
  constructor(private readonly request: CreateGoalRequest) {}

  private async updateParentGoalMeasurement(data: CreateGoalFormData) {
    const parentGoalId =
      typeof data.goalAlignment === 'string'
        ? data.goalAlignment
        : data.goalAlignment?.value || data.goalAlignment?.id;

    if (parentGoalId && data.alignmentContribution) {
      await this.request.updateParentGoalMeasurement(
        parentGoalId,
        data.alignmentContribution,
      );
    }
  }

  @action
  async createGoal(data: CreateGoalFormData) {
    const convertedData = convertFormDataToAPIformat(data);
    const goalLabel = data.isKpi
      ? 'KPI'
      : capitalize(
          computeFrameworkVars(authStore?.auth?.user?.workspace?.framework)
            ?.g_oal,
        );

    try {
      const response = await this.request.createGoal({
        ...convertedData,
        currentValue: convertedData.startValue,
      });
      await this.updateParentGoalMeasurement(data);
      activateNotification({
        title: 'Success',
        content: `${goalLabel} has been successfully created`,
        kind: 'success',
      });
      return response;
    } catch (e: any) {
      activateNotification({
        title: 'Error',
        content: e?.response?.data?.message || e?.message,
        kind: 'error',
      });
      return false;
    }
  }

  @action
  async editGoal(data: CreateGoalFormData, goalId: string) {
    const convertedData = convertFormDataToAPIformat(data);
    const goalLabel = data.isKpi
      ? 'KPI'
      : capitalize(
          computeFrameworkVars(authStore?.auth?.user?.workspace?.framework)
            ?.g_oal,
        );

    try {
      await this.request.editGoal(convertedData, goalId);
      await this.updateParentGoalMeasurement(data);
      activateNotification({
        title: 'Success',
        content: `${goalLabel} updated`,
        kind: 'success',
      });
      return true;
    } catch (e: any) {
      activateNotification({
        title: 'Error',
        content: e?.response?.data?.message || e?.message,
        kind: 'error',
      });
      return false;
    }
  }

  async getAllGoalTemplates(page?: number, type?: string, limit?: number) {
    try {
      const response = await this.request.getAllGoalTemplates(
        page,
        type,
        limit,
      );

      return response;
    } catch (e: any) {
      activateNotification({
        title: 'Error',
        content: e?.response?.data?.message,
        kind: 'error',
      });
    }
  }
  async getTemplatesType() {
    try {
      const response = await this.request.getTemplatesType();

      return response;
    } catch (e: any) {
      activateNotification({
        title: 'Error',
        content: e?.response?.data?.message,
        kind: 'error',
      });
    }
  }
}
